<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="reportinfo" :rules="rules" ref="syscalcrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="所属组织" prop="org">
						<el-select style="width: 100%;" filterable clearable  @change="orgChange" :disabled="!canadd" v-model="reportinfo.orgid" placeholder="请选择校区">
							<el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="年份" prop="year">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="reportinfo.year" :precision="0" :min="2020"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="月份" prop="month">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="reportinfo.month" :precision="0" :min="1" :max="12"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="12">
					<el-form-item label="总耗电" prop="totalpower">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="reportinfo.totalpower" :precision="2" :min="0"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="空调耗电" prop="airpower">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="reportinfo.airpower" @change="powerDataChange('air',$event)" :precision="2" :min="0"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="照明耗电" prop="lightpower">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="reportinfo.lightpower" @change="powerDataChange('light',$event)" :precision="2" :min="0"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="其他耗电" prop="otherpower">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="reportinfo.otherpower" @change="powerDataChange('other',$event)" :precision="2" :min="0"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="24">
					<el-form-item label="报表文件路径" prop="path">
						<el-input style="width: 100%;" :disabled="!editok" v-model="reportinfo.path" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-for="(rd, idx) in reportinfo.realdatas" :key="rd.PointCode">
				<el-col :span="12" >
					<el-form-item label-width="200px" :label="rd.PointName + '月初'" >
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="rd.Beg_Data" :precision="2" :min="-99998" @change="realDataChange('begin',idx,$event)"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="12" >
					<el-form-item label-width="200px" :label="rd.PointName + '月末'" >
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="rd.End_Data" :precision="2" :min="-99998" @change="realDataChange('end',idx,$event)"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveHisSet">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { editHisPower, queryHisPowerset, queryMutilPropertys, addHisPower } from '/static/apiUrl.js'
	import { Decimal } from 'decimal.js'
	export default {
		name : 'ReportDetail',
		data() {
			return {
				editok: false,
				canadd : false,
				disabled_cord: false,
				reportinfo : {
					id: "",
					orgid: "",
					orgnam : '',
					year: 0,
					month: 0,
					totalpower : '',
					airpower: "",
					lightpower: "",
					otherpower : '',
					realdata : '',
					realdatas : [],
					path : ''
				},
				rules:{
					orgid: [
						{ required: true, message: '请选择组织', trigger: 'blur' }
					],
					totalpower: [
						{ required: true, message: '请填写总耗电', trigger: 'blur' }
					],
					path: [
						{ required: true, message: '请填写报表文件路径', trigger: 'blur' }
					],
				},
				caclList : {
					total : [],
					air : [],
					light : [],
					other : []
				},
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedhis: {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			},
			orgList : {
				type : Array,
				required: true
			},
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
						this.canadd = true
					}else{
						this.editok = false
						this.canadd = false
					}
				}
			},
			orgList : {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
				}
			},
			selectedhis: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						console.log(newVal)
						this.reportinfo.id = newVal.id
						this.reportinfo.orgid = newVal.orgid
						this.reportinfo.orgnam = newVal.orgnam
						this.reportinfo.totalpower = newVal.totalpower
						this.reportinfo.airpower = newVal.airpower
						this.reportinfo.lightpower = newVal.lightpower
						this.reportinfo.otherpower = newVal.otherpower
						this.reportinfo.year = newVal.year
						this.reportinfo.month = newVal.month
						if(newVal.realdata){
							this.reportinfo.realdata = newVal.realdata
							this.reportinfo.realdatas = JSON.parse(newVal.realdata)
						}
						this.reportinfo.path = newVal.path
						this.initData()
					}else{
						this.reportinfo.id = ''
						this.reportinfo.orgid = ''
						this.reportinfo.orgnam = ''
						this.reportinfo.totalpower = ''
						this.reportinfo.airpower = ''
						this.reportinfo.lightpower = ''
						this.reportinfo.otherpower = ''
						let date = new Date()
						this.reportinfo.year = date.getFullYear()
						this.reportinfo.month = date.getMonth() + 1
						this.reportinfo.realdatas = []
						this.reportinfo.realdata = ''
						this.reportinfo.path = ''
					}
				}
			},
		},
		methods: {
			initData(type){
				if(this.reportinfo.orgid != ''){
					this.caclList.total = []
					this.caclList.air = []
					this.caclList.light = []
					this.caclList.other = []
					queryHisPowerset({oid: this.reportinfo.orgid}).then(res => {
						if(0 == res.code){
							let ids = []
							if(res.datas.totalpower){
								this.caclList.total = res.datas.totalpower.split(',')
								this.caclList.total.forEach((it) => {
									if(!ids.includes(it)){
										ids.push(it)
									}
								})
							}
							if(res.datas.airpower){
								this.caclList.air = res.datas.airpower.split(',')
								this.caclList.air.forEach((it) => {
									if(!ids.includes(it)){
										ids.push(it)
									}
								})
							}
							if(res.datas.lightpower){
								this.caclList.light = res.datas.lightpower.split(',')
								this.caclList.light.forEach((it) => {
									if(!ids.includes(it)){
										ids.push(it)
									}
								})
							}
							if(res.datas.otherpower){
								this.caclList.other = res.datas.otherpower.split(',')
								this.caclList.other.forEach((it) => {
									if(!ids.includes(it)){
										ids.push(it)
									}
								})
							}
							//console.log(this.caclList)
							if("1" == type){
								queryMutilPropertys(ids).then(res => {
									if(0 == res.code){
										res.datas.forEach((op) => {
											this.reportinfo.realdatas.push({
												PointCode : op.id ,
												PointName : op.devname ,
												Beg_Data : 0,
												End_Data : 0,
												Beg_Data_str : "0",
												End_Data_str : "0",
												Power_Consumption : 0,
											})
										})
									}
								})
							}
						}
					})
				}
			},
			orgChange(val){
				if(val){
					this.orgList.forEach((it) => {
						if(val == it.id){
							this.reportinfo.orgnam = it.name
						}
					})
					this.initData("1")
				}
			},
			realDataChange(type, idx, vl){
				//console.log(vl)
				let dvl = new Decimal(vl)
				if('begin' == type){
					this.reportinfo.realdatas[idx].Beg_Data = Number(dvl.toFixed(2))
					if(dvl.equals(new Decimal(-99998))){
						this.reportinfo.realdatas[idx].Beg_Data_str = '-'
					}else{
						this.reportinfo.realdatas[idx].Beg_Data_str = '' + Number(dvl.toFixed(2))
					}
				}else if('end' == type){
					this.reportinfo.realdatas[idx].End_Data = Number(dvl.toFixed(2))
					if(dvl.equals(new Decimal(-99998))){
						this.reportinfo.realdatas[idx].End_Data_str = '-'
					}else{
						this.reportinfo.realdatas[idx].End_Data_str = '' + Number(dvl.toFixed(2))
					}
				}
				let end = new Decimal(this.reportinfo.realdatas[idx].End_Data)
				let begin = new Decimal(this.reportinfo.realdatas[idx].Beg_Data)
				if(end.greaterThan(begin)){
					//console.log("-----")
					let consumption = end.minus(begin)
					this.reportinfo.realdatas[idx].Power_Consumption = Number(consumption.toFixed(2))
				}else{
					this.reportinfo.realdatas[idx].Power_Consumption = 0.0
				}
				console.log(this.reportinfo.realdatas[idx])
				this.caclAll()
			},
			caclAll(){
				if(this.caclList.total.length > 0 && this.reportinfo.realdatas.length > 0){
					let tmp = new Decimal(0)
					this.caclList.total.forEach((tp) => {
						this.reportinfo.realdatas.forEach((rd) => {
							if(tp == rd.PointCode){
								tmp = tmp.add(new Decimal(rd.Power_Consumption))
							}
						})
					})
					this.reportinfo.totalpower = Number(tmp.toFixed(2))
				}
				if(this.caclList.air.length > 0 && this.reportinfo.realdatas.length > 0){
					let tmp = new Decimal(0)
					this.caclList.air.forEach((tp) => {
						this.reportinfo.realdatas.forEach((rd) => {
							if(tp == rd.PointCode){
								tmp = tmp.add(new Decimal(rd.Power_Consumption))
							}
						})
					})
					this.reportinfo.airpower = Number(tmp.toFixed(2))
				}
				if(this.caclList.light.length > 0 && this.reportinfo.realdatas.length > 0){
					let tmp = new Decimal(0)
					this.caclList.light.forEach((tp) => {
						this.reportinfo.realdatas.forEach((rd) => {
							if(tp == rd.PointCode){
								tmp = tmp.add(new Decimal(rd.Power_Consumption))
							}
						})
					})
					this.reportinfo.lightpower = Number(tmp.toFixed(2))
				}
				if(this.caclList.other.length > 0 && this.reportinfo.realdatas.length > 0){
					let tmp = new Decimal(0)
					this.caclList.other.forEach((tp) => {
						this.reportinfo.realdatas.forEach((rd) => {
							if(tp == rd.PointCode){
								tmp = tmp.add(new Decimal(rd.Power_Consumption))
							}
						})
					})
					this.reportinfo.otherpower = Number(tmp.toFixed(2))
				}
			},
			powerDataChange(type, val){
				console.log(type, val)
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRefrash",false,false)
				}
			},
			saveHisSet(){
				this.$refs["syscalcrule"].validate((valid) => {
					if (valid) {
						this.reportinfo.realdata = JSON.stringify(this.reportinfo.realdatas)
						console.log(this.reportinfo)
						if(this.reportinfo.id != null && this.reportinfo.id != ''){  //编辑
							editHisPower(this.reportinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "更新成功",
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}else{ //新增
							addHisPower(this.reportinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: '新增成功',
										type: 'success'
									});
									this.$emit("needRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>